import { IModel } from '@pia/pia.shared';

import { Command } from './command';
import { ICommand } from './contracts/command';

export class EntityCreateCommand<T extends IModel> extends Command implements ICommand {
  constructor(
    public entity: T,
    public channel: string,
    dtoName: string,
    public additionalSyncInfo?: Record<string, any>
  ) {
    super(dtoName);
  }
}
